<template>
  <div>
    <div slot="title">
      <h2 class="label-black" v-if="idLeyenda == null">Nueva Leyenda de Retroalimentación</h2>
      <h2 class="label-black" v-else>Editar Leyenda de Retroalimentación</h2>
    </div>
    <div class="row" style="margin-top:20px" v-if="idLeyenda!=null">
      <div class="col-2">
        <router-link :to="{ name: 'CatalogoLeyendasRetroalimentacion' }">
          <button type="button" class="form-control btn-custom"><i class="fa fa-arrow-left"></i><span class="col-form-label" style="margin-left:50px">Regresar</span></button>
        </router-link>
      </div>
    </div>
    <div slot="main">
      <div class="container-fluid">
        <div class="row new-row">
          <div class="col-2"><b class="label-black">Leyenda de retroalimentación :</b></div>
          <div class="col-8">
            <textarea class="form-control" cols="25" rows="3" v-model="leyenda">
            </textarea>
          </div>
        </div>
        <div class="row jump-row">
          <div class="col-2"><b class="label-black">Tipo de Leyenda :</b></div>
          <div class="col-2">
            <select class="form-control" v-model="tipoLeyenda">
              <option value="0">Genérica</option>
              <option value="1">Específica</option>
            </select>
          </div>
        </div>
        <template v-if="tipoLeyenda == 0">
          <div class="row jump-row">
            <div class="col-2"><b class="label-black">Parámetros :</b></div>
            <div class="col-10"> <input type="checkbox" v-model="Fortalezas"> <span class="label-black">Con Fortalezas</span> </div>
          </div>
          <div class="row jump-row">
            <div class="col-2"></div>
            <div class="col-10"> <input type="checkbox" v-model="AreasDeOportunidad">  <span class="label-black">Con Áreas de Oportunidad</span> </div>
          </div>
          <div class="row jump-row">
            <div class="col-2"></div>
            <div class="col-10"> <input type="checkbox" v-model="ComentariosNegativos">  <span class="label-black">Con Comentarios Negativos</span> </div>
          </div>
        </template>
        <template v-if="tipoLeyenda == 1">
          <div class="row jump-row">
            <div class="col-2"><b>Categría de Observación: </b></div>
            <div class="col-8"> <input type="text" v-model="categoriaObservacion" class="form-control"> </div>
          </div>
        </template>
        <div class="row jump-row">
          <div class="col-8"></div>
          <div class="col-2">
            <button class="form-control btn-custom" v-bind:disabled="!validarFormulario" @click="guardarLeyenda">Guardar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import comun from '@/../static/js/comun'
  import enumeraciones from '@/../static/js/enumeraciones'
  import api from '@/../static/js/api'
  import axios from 'axios'

  export default {
    props: {
      idLeyenda: {
        type: Number,
        default: null
      },
      tipoLeyendaProp: {
        type: Number,
        default: null
      }
    },
    data() {
      return this.valoresIniciales();
    },
    components: {

    },
    methods: {
      valoresIniciales: function () {
        return {
          leyenda: "",
          leyendaValida: false,
          categoriaObservacionValida: false,
          Fortalezas: false,
          AreasDeOportunidad: false,
          ComentariosNegativos: false,
          tipoLeyenda: 0,
          categoriaObservacion: ""
        }
      },
      guardarLeyenda: function () {
        if (this.tipoLeyenda == 0) {
          this.crearLeyendaGenerica();
        }
        else if (this.tipoLeyenda == 1) {
          this.crearLeyendaEspecifica();
        }
      },
      crearLeyendaGenerica: function () {
        var peticion = {//Carga los valores para enviar la petición de busqueda
          "esPrueba": false,
          "LeyendaRetroalimentacionGenericaId": this.idLeyenda,
          "Leyenda": this.leyenda,
          "Fortalezas": this.Fortalezas,
          "AreasDeOportunidad": this.AreasDeOportunidad,
          "ComentariosNegativos": this.ComentariosNegativos
        }
        //console.log(peticion)
        axios.post(api.conexion + api.SISEVA.funcion.GuardarNuevaLeyendaRetroalimentacionGenerica, peticion).then(response => {
          if (response.data.SiHayError == false) {
            comun.mensajeDeAlerta(response.data.Satisfactorio, null, null)
            if (this.idLeyenda == null) {
              Object.assign(this.$data, this.valoresIniciales());
            }
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
            // this.error = response.data.Error.Mensaje;
            // $('#modalInvalidezAlerta').modal('show');
          }
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      },
      crearLeyendaEspecifica: function () {
        var peticion = {//Carga los valores para enviar la petición de busqueda
          "esPrueba": false,
          "LeyendaRetroalimentacionEspecificaId": this.idLeyenda,
          "Leyenda": this.leyenda,
          "CategoriaDeObservacion": this.categoriaObservacion
        }
        //console.log(peticion)
        axios.post(api.conexion + api.SISEVA.funcion.GuardarNuevaLeyendaRetroalimentacionEspecifica, peticion).then(response => {
          if (response.data.SiHayError == false) {
            comun.mensajeDeAlerta(response.data.Satisfactorio, null, null)
            if (this.idLeyenda == null) {
              Object.assign(this.$data, this.valoresIniciales());
            }
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
            // this.error = response.data.Error.Mensaje;
            // $('#modalInvalidezAlerta').modal('show');
          }
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      },
      getInfoLeyenda: function () {
        this.tipoLeyenda = this.tipoLeyendaProp
        if (this.tipoLeyendaProp == 0) {
          this.getLeyendaGenerica();
        }
        else if (this.tipoLeyendaProp == 1) {
          this.getLeyendaEspecifica();
        }
      },
      getLeyendaGenerica: function () {
        var peticion = {
          "esPrueba": false,
          "LeyendaRetroalimentacionGenericaId": this.idLeyenda
        }
        axios.post(api.conexion + api.SISEVA.funcion.GetLeyendaRetroalimentacionGenerica, peticion).then(response => {
          if (response.data.SiHayError == false) {
            this.leyenda = response.data.LeyendaRetroalimentacionGenerica.Leyenda
            this.Fortalezas = response.data.LeyendaRetroalimentacionGenerica.Fortalezas
            this.AreasDeOportunidad = response.data.LeyendaRetroalimentacionGenerica.AreasDeOportunidad
            this.ComentariosNegativos = response.data.LeyendaRetroalimentacionGenerica.ComentariosNegativos
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      },
      getLeyendaEspecifica: function () {
        var peticion = {
          "esPrueba": false,
          "LeyendaRetroalimentacionEspecificaId": this.idLeyenda
        }
        axios.post(api.conexion + api.SISEVA.funcion.GetLeyendaRetroalimentacionEspecifica, peticion).then(response => {
          if (response.data.SiHayError == false) {
            this.leyenda = response.data.LeyendaRetroalimentacionEspecifica.Leyenda
            this.categoriaObservacion = response.data.LeyendaRetroalimentacionEspecifica.CategoriaDeObservacion        
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      },
      validarTextArea: function (str, l) {
        let remText = str.replace(/ /g, "");
        let length = remText.length;
        return length > l;
      }
      
    },
    watch: {
      leyenda: function (val) {
        this.leyendaValida = this.validarTextArea(val, 10)
      },
      categoriaObservacion: function (val) {
        this.categoriaObservacionValida = this.validarTextArea(val, 0)
      }
      
    },
    computed: {
       
      validarFormulario: function () {
        return this.leyendaValida && (this.tipoLeyenda == 0 || this.categoriaObservacionValida );
      }
    },
    mounted: function () {
      if (this.idLeyenda != null && this.tipoLeyendaProp != null) {
          this.getInfoLeyenda();
        }
    }
  }

</script>

<style scoped>
  .new-row {
    margin-top:50px;
  }
  .jump-row {
    margin-top:25px;
  }
  input[type=checkbox] {
  margin-right: 5px;
}
.custom-area {
        background-color: #7e7f74;
    }
    .label-black {
        color: black;
    }
    .btn-custom {
        background-color: #004746;
        color: white;
    }
</style>



// WEBPACK FOOTER //
// src/components/SISEVA/Psicologia/NuevaLeyendaRetroalimentacion.vue